import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { BookmarksContext } from "./context";
import { ActualFundType } from "@constants/funds-data";
import { fetchFundsList } from "@/api/overview";

interface Props {
  children: React.ReactNode;
}

const BookmarkProvider = ({ children }: Props) => {
  const [funds, setFunds] = useState<ActualFundType[]>([]);
  const [bookmarks, setBookmarks] = useState<ActualFundType["name"][]>(
    () => {
      const storedBookmarks = localStorage.getItem("bookmarks");
      if (storedBookmarks) {
        return JSON.parse(storedBookmarks) as ActualFundType["name"][];
      }

      return [];
    },
  );

  const handleBookmark = (fund_name: ActualFundType["name"]) => {
    setBookmarks((prev) => {
      if (prev.includes(fund_name)) {
        return prev.filter((id) => id !== fund_name);
      }

      return [...prev, fund_name];
    });
  };

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["funds"],
    queryFn: fetchFundsList,
  });

  useEffect(() => {
    if (!(isLoading || isFetching) && !!data) setFunds(data);
  }, [data, isLoading, isFetching]);

  useEffect(() => {
    localStorage.setItem("bookmarks", JSON.stringify(bookmarks));
  }, [bookmarks]);

  return (
    <BookmarksContext.Provider
      value={{
        funds,
        bookmarks,
        topChangeDaily: [],
        topOutflow: [],
        topInflow: [],
        isFundsLoading: isLoading || isFetching,
        handleBookmark,
      }}
    >
      {children}
    </BookmarksContext.Provider>
  );
};

export default BookmarkProvider;
